import { useMutation } from "@tanstack/react-query";
import { journalsServiceApi } from "@entities/api";

interface IUseGetSigningString {
  sectionTwoListId: string;
  itemNoVersionId: string;
}

interface IRequest {
  signerEmployeeId: string;
}

export function useGetSigningString({
  sectionTwoListId,
  itemNoVersionId,
}: IUseGetSigningString) {
  return useMutation({
    mutationFn: (data: IRequest) =>
      journalsServiceApi
        .post<string>(
          `/journals/section-two/${sectionTwoListId}/items/${itemNoVersionId}/sign`,
          data,
        )
        .then((r) => r.data),
  });
}
